/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Trascina per ridimensionare il pannello',
  command_intelligence_close_aria: 'Chiudi assistente',
  command_intelligence_send_aria: 'Invia messaggio',
  command_intelligence_stop_aria: 'Interrompi risposta',
  command_intelligence_composer_input_aria: 'Messaggio a Command Intelligence',
  command_intelligence_drawer_more_options: 'Altre opzioni',
  command_intelligence_dock_position: 'Posizione aggancio',
  command_intelligence_dock_left: 'Sinistra',
  command_intelligence_dock_right: 'Destra',
  command_intelligence_dock_top: 'Alto',
  command_intelligence_dock_bottom: 'Basso',
  command_intelligence_panel_layout: 'Layout pannello',
  command_intelligence_panel_layout_overlap: 'Sovrapponi contenuto',
  command_intelligence_panel_layout_push: 'Sposta contenuto',
  command_intelligence_panel_auto_hide_overlap: 'Nascondi automaticamente cliccando fuori',
  command_intelligence_session_reset: 'Reimposta conversazione',
  command_intelligence_try_one_of_these: 'Prova uno di questi',
  command_intelligence_attach_hint: 'Allega elementi di contesto per iniziare a fare domande.',
  command_intelligence_welcome_subhead: 'Fai una domanda per iniziare.',
  command_intelligence_attach_modal_title: 'Allega contesto',
  command_intelligence_attach_modal_subtitle:
    'Scegli dagli elementi in questa vista. Gli elementi già allegati sono disattivati.',
  command_intelligence_attach_modal_search_placeholder: 'Cerca…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# elemento disponibile} other {# elementi disponibili}} · {selected} selezionati',
  command_intelligence_attach_modal_empty: 'Niente disponibile da allegare',
  command_intelligence_attach_modal_no_results: 'Nessun elemento corrisponde alla ricerca',
  command_intelligence_context_bar_attached_section: 'Allegati ({count})',
  command_intelligence_context_bar_clear_attached: 'Cancella',
  command_intelligence_context_bar_add: 'Allega contesto',
  command_intelligence_placeholder_ready: 'Fai una domanda…',
  command_intelligence_placeholder_attach: 'Allega contesto per fare una domanda…',
  command_intelligence_composer_submit_hint: 'Invio per inviare · Maiusc+Invio per nuova riga',
  command_intelligence_composer_stop_hint: 'Interrompi · bozza del prossimo messaggio in attesa',
  command_intelligence_response_stopped: 'Risposta interrotta',
  command_intelligence_generation_in_progress: 'Elaborazione della tua domanda',
  command_intelligence_generation_trace_title: 'Passaggi eseguiti',
  command_intelligence_generation_trace_toggle: 'Mostra passaggi',
  command_intelligence_generation_trace_summary: '{completed} di {total} passaggi completati',
  command_intelligence_generation_trace_summary_generic: 'Passaggi di generazione',
  command_intelligence_generation_tool_count: '{count, plural, one {# strumento} other {# strumenti}}',
  command_intelligence_generation_turn_label: 'Turno {turn} di {total}',
  command_intelligence_generation_turn_completed: 'Turno {turn} di {total} completato',
  command_intelligence_generation_turn_completed_elapsed: 'Turno {turn} di {total} completato ({seconds}s trascorsi)',
  command_intelligence_generation_turn_completed_with_tools: 'Turno {turn} di {total} completato – usati {tools}',
  command_intelligence_generation_tools_used: 'Usati {tools}',
  command_intelligence_reasoning_thinking: 'Sto pensando…',
  command_intelligence_reasoning_thought_for_seconds: 'Ha riflettuto per {seconds} secondi',
  command_intelligence_reasoning_waiting: 'Elaborazione della tua domanda…',
  command_intelligence_attach_modal_done: 'Fine',
  command_intelligence_attach_modal_attached_badge: 'allegato',
  command_intelligence_attach_modal_attach: 'Allega',
  command_intelligence_attach_modal_attach_count: 'Allega ({count})',
  command_intelligence_attach_modal_close_aria: 'Chiudi selettore',
  command_intelligence_session_limit_context:
    'Limite di contesto raggiunto. Reimposta la conversazione per continuare.',
  command_intelligence_session_limit_prompt: 'Limite di messaggi raggiunto. Reimposta la conversazione per continuare.',
  command_intelligence_suggested_followups: 'Follow-up suggeriti',
  command_intelligence_credit_warning_line: '{pct}% dei crediti IA mensili di {scope} utilizzati',
  command_intelligence_tooltip_prompts: '{count} di {max} messaggi ({pct}%)',
  command_intelligence_tooltip_context: '{used} di {max} token di contesto ({pct}%)',
  command_intelligence_tooltip_context_idle: 'L’uso del contesto appare dopo la prima risposta',
  command_intelligence_credits_loading: 'Caricamento crediti…',
  command_intelligence_credits_unavailable: 'Crediti non disponibili',
  command_intelligence_credits_tooltip: 'Crediti IA mensili per {monthKey}',
  command_intelligence_credits_tooltip_short: 'Crediti IA mensili',
  command_intelligence_credits_scope_profile: 'Profilo',
  command_intelligence_credits_scope_entity: 'Entità',
  command_intelligence_credits_used_of_cap: '{used} di {cap} crediti',
  command_intelligence_credits_used_no_cap: '{used} crediti utilizzati',
  command_intelligence_credits_monthly_title: 'Crediti IA mensili',
  command_intelligence_compare_aria: 'Confronta agenti',
  command_intelligence_compare_tooltip: 'Esegui la stessa domanda su più profili agente',
  command_intelligence_compare_cancelled: 'Confronto annullato',
  command_intelligence_compare_branch_failed: 'Ramo di confronto non riuscito',
  command_intelligence_compare_title: 'Confronto agenti',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} in / {outTok} out · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Buona risposta',
  command_intelligence_feedback_bad_response: 'Risposta scadente',
  command_intelligence_feedback_dialog_title: 'Invia feedback',
  command_intelligence_feedback_dialog_body:
    'Aiutaci a migliorare inviando feedback su questa risposta. Il feedback sarà inviato al nostro team operativo.',
  command_intelligence_feedback_response_label: 'Risposta',
  command_intelligence_feedback_input_label: 'Il tuo feedback (facoltativo)',
  command_intelligence_feedback_input_placeholder: 'Cosa non ha funzionato o non è stato utile in questa risposta?',
  command_intelligence_feedback_submit: 'Invia feedback',
  command_intelligence_feedback_submit_error: 'Invio feedback non riuscito. Riprova.',
  command_intelligence_feedback_question_understanding: 'L’agente ha capito cosa volevi?',
  command_intelligence_feedback_question_readability: 'La risposta era facile da leggere e usare?',
  command_intelligence_feedback_section_understanding: 'Comprensione',
  command_intelligence_feedback_section_readability: 'Leggibilità',
  command_intelligence_feedback_choice_none: 'Nessuno',
  command_intelligence_feedback_choice_misunderstood_task: 'Compito frainteso',
  command_intelligence_feedback_choice_ignored_constraint: 'Vincolo ignorato',
  command_intelligence_feedback_choice_wrong_scope: 'Ambito errato',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visivamente difficile da leggere',
  command_intelligence_feedback_choice_wrote_too_much: 'Troppo verboso',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Spiegazione poco attendibile',
  command_intelligence_copy_aria: 'Copia negli appunti',
  command_intelligence_error_missing_invoke_permission:
    'Non hai l’autorizzazione per usare Command Intelligence con questo agente. Chiedi all’amministratore di concedere le autorizzazioni Intelligence necessarie (ad esempio analyst).',
  command_intelligence_access_denied_title: 'Accesso richiesto',
  command_intelligence_error_session_expired: 'La sessione è scaduta. Aggiorna la pagina e accedi di nuovo.',
};
